<div class="container">
    <div class="container">

        @if (viewModel$ | async; as viewModel) {

            @if (isLoading()) {

            <div class="section">
                <div class="label">Average Daily Membership (ADM)</div>
                <div class="card rounded-corners">
                    <mat-spinner class="adm-loader"></mat-spinner>
                </div>
            </div>
            <div class="section">
                <div class="label"></div>
                <div class="card rounded-corners">
                    <mat-spinner class="adm-loader"></mat-spinner>
                </div>
            </div>

            <div class="section">
                <div class="label">Year over Year Base ADM</div>
                <div class="card2 rounded-corners">
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                </div>
            </div>
            
            <div class="section">
                <div class="label">Year over Year Membership</div>
                <div class="card2 rounded-corners">
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                </div>
            </div>
            
            } @else {

                <div class="section">
                    <div class="label">Average Daily Membership (ADM)</div>
                    <div class="card rounded-corners">
                        <div class="number">{{ viewModel.currentBaseAdm | number: '1.0-0' }}</div>
                        <div class="label">Base ADM</div>
                    </div>
                </div>
                <div class="section">
                    <div class="label"></div>
                    <div class="card rounded-corners">
                        <div class="number">{{ viewModel.currentMembership | number: '1.0-0' }}</div>
                        <div class="label">Membership</div>
                    </div>
                </div>

                <div class="section">
                    <div class="label">Year over Year Base ADM</div>
                    <div class="card2 rounded-corners">
                        <div class="card">
                            <div class="number">{{ viewModel.previousBaseAdm | number: '1.0-0' }}</div>
                            <div class="label">{{ viewModel.previousYear }}</div>
                        </div>
                        <div class="card">
                            <div class="number">{{ viewModel.currentBaseAdm | number: '1.0-0' }}</div>
                            <div class="label">{{ viewModel.currentYear }}</div>
                        </div>
                    </div>
                </div>
                
                <div class="section">
                    <div class="label">Year over Year Membership</div>
                    <div class="card2 rounded-corners">
                        <div class="card">
                            <div class="number">{{ viewModel.previousMembership | number: '1.0-0' }}</div>
                            <div class="label">{{ viewModel.previousYear }}</div>
                        </div>
                        <div class="card">
                            <div class="number">{{ viewModel.currentMembership | number: '1.0-0' }}</div>
                            <div class="label">{{ viewModel.currentYear }}</div>
                        </div>
                    </div>
                </div>

            }

        } @else {

            <div class="section">
                <div class="label">Average Daily Membership (ADM)</div>
                <div class="card rounded-corners">
                    <mat-spinner class="adm-loader"></mat-spinner>
                </div>
            </div>
            <div class="section">
                <div class="label"></div>
                <div class="card rounded-corners">
                    <mat-spinner class="adm-loader"></mat-spinner>
                </div>
            </div>

            <div class="section">
                <div class="label">Year over Year Base ADM</div>
                <div class="card2 rounded-corners">
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                </div>
            </div>
            
            <div class="section">
                <div class="label">Year over Year Membership</div>
                <div class="card2 rounded-corners">
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                    <div class="card">
                    <mat-spinner class="adm-loader"></mat-spinner>
                    </div>
                </div>
            </div>

        }

    </div>
</div>
